import { Controller } from "@hotwired/stimulus";
import Swal from "sweetalert2";

export default class extends Controller {
  static targets = [
    "termsContainer",
    "redirectingContainer",
    "checkbox",
    "proceedButton",
    "formularioBiometria",
    "nome",
    "documentoTipo",
    "documentoNumero",
    "dataNascimento",
    "termoConsentimentoResponsavel",
    "checkboxtermoConsentimentoResponsavel",
  ];

  static values = {
    config: Object,
  };

  connect() {
    if (this.hasCheckboxTarget) {
      this.proceedButtonTarget.classList.add("disable");
      this.checkboxTarget.checked = false;
    }

    if (this.hasDocumentoTipoTarget) this.documentoTipoChanged();
    if (this.hasDataNascimentoTarget) this.dataNascimentoChanged();
    if (this.configValue.pularTermos) this.redirect();
  }

  toggleButtonState() {
    if (this.podeProsseguir()) {
      this.proceedButtonTarget.classList.remove("disable");
    } else {
      this.proceedButtonTarget.classList.add("disable");
    }
  }

  podeProsseguir() {
    if (!this.hasCheckboxTarget || !this.checkboxTarget.checked) return false;
    if (
      this.termoConsentimentoResponsavelVisivel() &&
      !this.checkboxtermoConsentimentoResponsavelTarget.checked
    )
      return false;

    return true;
  }

  termoConsentimentoResponsavelVisivel() {
    return (
      this.hasTermoConsentimentoResponsavelTarget &&
      !this.termoConsentimentoResponsavelTarget.classList.contains("hidden")
    );
  }

  dataNascimentoChanged() {
    if (
      !this.hasTermoConsentimentoResponsavelTarget ||
      !this.configValue.exigirTermoConsentimentoResponsavel
    )
      return;

    const valor = this.hasDataNascimentoTarget
      ? this.dataNascimentoTarget.value
      : "";
    if (this.menorDeDezoito(valor)) {
      this.termoConsentimentoResponsavelTarget.classList.remove("hidden");
    } else {
      this.termoConsentimentoResponsavelTarget.classList.add("hidden");
      if (this.hasCheckboxtermoConsentimentoResponsavelTarget)
        this.checkboxtermoConsentimentoResponsavelTarget.checked = false;
    }

    if (this.hasProceedButtonTarget) this.toggleButtonState();
  }

  menorDeDezoito(valor) {
    const texto = (valor || "").trim();
    const brasileiro = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(texto);
    const iso = /^(\d{4})-(\d{2})-(\d{2})$/.exec(texto);
    let dia;
    let mes;
    let ano;

    if (brasileiro) {
      dia = Number(brasileiro[1]);
      mes = Number(brasileiro[2]);
      ano = Number(brasileiro[3]);
    } else if (iso) {
      ano = Number(iso[1]);
      mes = Number(iso[2]);
      dia = Number(iso[3]);
    } else {
      return false;
    }
    const nascimento = new Date(ano, mes - 1, dia);
    if (
      nascimento.getFullYear() !== ano ||
      nascimento.getMonth() !== mes - 1 ||
      nascimento.getDate() !== dia
    ) {
      return false;
    }

    const hoje = new Date();
    const limite = new Date(
      hoje.getFullYear() - 18,
      hoje.getMonth(),
      hoje.getDate(),
    );
    return nascimento.getTime() > limite.getTime();
  }

  documentoTipoChanged() {
    const tipo = this.documentoTipoTarget.value.toLowerCase();

    if (tipo === "cpf") {
      this.documentoNumeroTarget.classList.add("mask-cpf");
      this.documentoNumeroTarget.classList.remove("mask-passport");

      window.Mascaras?.maskCpf.mask(this.documentoNumeroTarget);
    } else if (tipo === "passport") {
      this.documentoNumeroTarget.classList.remove("mask-cpf");
      window.Mascaras.unmask(this.documentoNumeroTarget);
    }
  }

  proceed(event) {
    event.preventDefault();

    if (!this.checkboxTarget.checked) {
      Swal.fire({
        icon: "error",
        title: "Aceite os termos",
        text: "Confirme os termos para continuar com o cadastro.",
      });
      return;
    }

    if (
      this.termoConsentimentoResponsavelVisivel() &&
      !this.checkboxtermoConsentimentoResponsavelTarget.checked
    ) {
      Swal.fire({
        icon: "error",
        title: "Aceite o termo",
        text: "Aceite o termo de consentimento para menores de 18 anos para continuar.",
      });
      return;
    }

    if (this.hasFormularioBiometriaTarget) {
      this.clearErrors();
      const errors = this.validateFields();
      if (Object.keys(errors).length > 0) {
        this.displayErrors(errors);
        return;
      }

      const fields = {
        facial_gateway_id: this.configValue.facialGatewayId,
        origem: this.configValue.origem,
        anuncio_id: this.configValue.anuncioId,
        back_url: this.configValue.back_url,
        follow_url: this.configValue.follow_url,
        pular_termos: true,
      };

      Object.entries(fields).forEach(([name, value]) => {
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = name;
        input.value = value;
        this.formularioBiometriaTarget.appendChild(input);
      });

      if (
        this.termoConsentimentoResponsavelVisivel() &&
        this.checkboxtermoConsentimentoResponsavelTarget.checked
      ) {
        const aceite = document.createElement("input");
        aceite.type = "hidden";
        aceite.name = "aceitou_termo_de_consentimento_responsavel";
        aceite.value = "1";
        this.formularioBiometriaTarget.appendChild(aceite);
      }
    }

    this.redirect();
  }

  redirect() {
    if (this.hasTermsContainerTarget)
      this.termsContainerTarget.classList.add("hidden");
    if (this.hasRedirectingContainerTarget)
      this.redirectingContainerTarget.classList.remove("hidden");

    if (!this.configValue.pularTermos && this.hasFormularioBiometriaTarget) {
      this.formularioBiometriaTarget.submit();
      return;
    }

    const destino =
      this.termoConsentimentoResponsavelVisivel() &&
      !this.configValue.pularTermos
        ? this.urlComAceiteDoTermoDeConsentimentoResponsavel()
        : this.configValue.url;

    setTimeout(() => {
      window.location.href = destino;
    }, 4000);
  }

  urlComAceiteDoTermoDeConsentimentoResponsavel() {
    const destino = new URL(window.location.href);
    destino.searchParams.set("aceitou_termo_de_consentimento_responsavel", "1");
    return destino.toString();
  }

  validateFields() {
    const errors = {};

    const nome = this.nomeTarget.value.trim();
    const documentoTipo = this.documentoTipoTarget.value.toLowerCase();
    const documentoNumero = this.documentoNumeroTarget.value
      ?.toUpperCase()
      .replace(/[^A-Z0-9/]+/g, "");

    if (!nome || nome.split(" ").length === 0) {
      errors.nome = ["Não pode ficar em branco."];
    } else if (nome && nome.split(" ").length === 1) {
      errors.nome = ["Digite o nome completo."];
    }

    if (/\s/.test(documentoNumero)) {
      this.documentoNumeroTarget.value = this.removerEspacos(documentoNumero);
    }

    if (["cpf", "passport"].includes(documentoTipo)) {
      if (documentoTipo === "cpf" && !this.validarCPF(documentoNumero)) {
        errors.documentoNumero = ["CPF inválido."];
      }
      if (documentoTipo === "passport" && documentoNumero.length <= 6) {
        errors.documentoNumero = ["Passaporte inválido."];
      }
    } else {
      errors.documentoTipo = ["Deve ser CPF ou Passaporte."];
    }

    return errors;
  }

  displayErrors(errors) {
    Object.entries(errors).forEach(([field, messages]) => {
      const target = this[`${field}Target`];
      if (!target) return;

      // encontra o container pai do Simple Form
      const container = target.closest(".input");
      if (!container) return;

      // adiciona classe de erro no container
      container.classList.add("field_with_errors");

      // marca o input como inválido
      target.setAttribute("aria-invalid", "true");

      // remove span de erro antigo (caso já exista)
      const oldError = container.querySelector("span.error");
      if (oldError) oldError.remove();

      // cria o span com a mensagem
      const errorSpan = document.createElement("span");
      errorSpan.classList.add("error");
      errorSpan.textContent = messages.join(", ");

      // adiciona logo após o input
      container.appendChild(errorSpan);
    });
  }

  clearErrors() {
    this.formularioBiometriaTarget
      .querySelectorAll(".field_with_errors")
      .forEach((container) => {
        container.classList.remove("field_with_errors");
        const span = container.querySelector("span.error");
        if (span) span.remove();
        const input = container.querySelector("[aria-invalid='true']");
        if (input) input.removeAttribute("aria-invalid");
      });
  }

  validarCPF(cpf) {
    cpf = cpf.replace(/[^\d]+/g, "");
    if (cpf.length !== 11 || /^(\d)\1+$/.test(cpf)) return false;
    const dez_ou_onze = (resto) => resto === 10 || resto === 11;

    let soma = 0;
    for (let i = 0; i < 9; i++) soma += parseInt(cpf.charAt(i)) * (10 - i);
    let resto = 11 - (soma % 11);
    if (dez_ou_onze(resto)) resto = 0;
    if (resto !== parseInt(cpf.charAt(9))) return false;

    soma = 0;
    for (let i = 0; i < 10; i++) soma += parseInt(cpf.charAt(i)) * (11 - i);
    resto = 11 - (soma % 11);
    if (dez_ou_onze(resto)) resto = 0;
    return resto === parseInt(cpf.charAt(10));
  }

  removerEspacos(texto) {
    if (typeof texto !== "string") return texto;
    return texto.replace(/\s+/g, "");
  }
}
